<template>
  <div>
    <div class="flexs">
      <sidebarUserInfo style="flex: 0 0 300px; height: fit-content" />
      <div style="flex: 1">
        <top-banner class="banners" />
        <div class="top-lists">
          <div
            class="nav-view"
            @click="$router.push(item.url)"
            :class="index == 2 ? 'styles' : ''"
            v-for="(item, index) in navList"
          >
            {{ item.name }}
          </div>
        </div>
        <div style="position: relative">
          <div class="content">
            <div class="title">
              <div class="line"></div>
              <div class="name">{{ $t('w_0127') }}</div>
            </div>
            <div class="search-sel">
              <div style="display: flex">
                <span>{{ $t('w_0128') }}:</span>
                <div>
                  <el-col :span="3" style="margin-left: 20px">
                    <el-date-picker
                      v-model="queryParams.startCreationTime"
                      type="datetime"
                      value-format="yyyy-MM-dd"
                      :placeholder="$t('CK_KS_3')"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col :span="3" style="margin-left: 160px">
                    <el-date-picker
                      v-model="queryParams.endCreationTime"
                      type="datetime"
                      value-format="yyyy-MM-dd"
                      :placeholder="$t('MN_T_7')"
                    >
                    </el-date-picker>
                  </el-col>
                </div>
                <el-col :span="4" style="margin-left: -110px">
                  <div class="searchbox">
                    <el-button class="btn1" @click="chongzhi">{{ $t('CK_KS_6') }}</el-button>
                    <el-button class="btn2" @click="research">{{ $t('N_I_183') }}</el-button>
                  </div>
                </el-col>
              </div>
            </div>
          </div>

          <div class="tablebox">
            <el-table
              :data="tableData"
              :header-cell-style="{ background: '#EEEEEE' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                      align="center"
                      prop="creationTime"
                      :label="$t('w_0128')"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="memberCode"
                :label="$t('w_0129')+'(PV)'"
              ></el-table-column>
                <el-table-column
                        align="center"
                        prop="memberCode"
                        :label="$t('w_0130')+'(PV)'"
                ></el-table-column>
                <el-table-column
                        align="center"
                        prop="memberCode"
                        :label="$t('w_0127')"
                ></el-table-column>
                <el-table-column
                        align="center"
                        prop="memberCode"
                        :label="$t('MY_TH_2')"
                ></el-table-column>
            </el-table>
<!--            <pagination-->
<!--              :total="total"-->
<!--              :page.sync="queryParams.pageNum"-->
<!--              :limit.sync="queryParams.pageSize"-->
<!--              @pagination="research"-->
<!--            />-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as apis from "@/api/index.js";
import sidebarUserInfo from "@/components/sidebarUserInfo";
import topBanner from "@/components/topBanner";
import * as api from "@/api/register";
import { getToken } from "@/util/auth";
import {getBiddingList} from "@/api/bonus";
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 50,
        startCreationTime: "",
        endCreationTime: "",
        memberCode: "",
        memberName: "",
      },
      navList: [
        { name: this.$t('w_0131'), url: "/superStudio" },
        { name: this.$t('PER_DA_10'), url: "/performance" },
        { name: this.$t('w_0127'), url: "/giftBag" },
      ],
    };
  },
  components: { sidebarUserInfo, topBanner },
  watch: {},
  mounted() {
      this.research()
  },
  methods: {
    research() {
        getBiddingList(this.queryParams).then((res) => {
            this.tableData = res.rows;
            this.total = res.total;
        });
    },
    chongzhi() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 50,
        startCreationTime: "",
        endCreationTime: "",
      };
      this.research();
    },
  },
};
</script>
<style>
.hide .el-upload--picture-card {
  display: none !important;
}
</style>
<style lang="scss" scoped>
::v-deep .el-table .cell{
  padding: 10px 0;
  //font-weight: 400;
}
::v-deep .el-table th.el-table__cell{
  color: #333;
  padding: 30px 0;
  font-weight: 600!important;
}
.btn1 {
  background: #d61820;
  border-radius: 8px 8px 8px 8px;
  color: #fff;
  height: 46px;
  padding: 0 24px;
}
.btn2 {
  background: #fff;
  border: 1px solid #cccccc;
  border-radius: 8px 8px 8px 8px;
  color: #666;
  height: 46px;
  padding: 0 24px;
}
.styles {
  border: none !important;
  color: #fff !important;
  background: #d61820;
}
.top-lists {
  display: flex;
  padding: 20px 0 0 0;
  .nav-view {
    cursor: pointer;
    padding: 0 26px;
    height: 44px;
    border-radius: 10px;
    border: 1px solid #999999;
    font-size: 14px;
    text-align: center;
    line-height: 44px;
    margin-right: 20px;
    color: #999;
  }
}
.width {
  position: relative;
  width: 128px;
  height: 128px;
}
.close-icon {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 20px;
  height: 20px;
}
.idCardWidth {
  width: 362px !important;
  height: 211px !important;
  position: relative;
  top: 0;
}
.card {
  width: 362px !important;
  height: 211px !important;
  position: relative;
}
.card img {
  width: 362px !important;
  height: 211px !important;
}
.centers {
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-list {
  //margin-left: -20px;
}
::v-deep .el-upload {
  display: flex;
}
.upload-demo {
  display: flex;
}
.text_s {
  position: absolute;
  top: 70px;
  right: 20px;
  width: 360px;
  line-height: 20px;
  color: #666;
  font-size: 12px;
}
.bolds {
  font-weight: bold;
}
.status-size {
  margin-top: 10px;
  font-size: 20px;
  color: #000;
}
.img_cen {
  padding: 200px 0;
  margin: 0 auto;
  text-align: center;
}
.status-img img {
  width: 80px;
  height: 80px;
}
.button-s {
  width: 290px;
  height: 66px;
  background: #d61820;
  border-radius: 10px 10px 10px 10px;
  text-align: center;
  cursor: pointer;
  line-height: 66px;
  font-size: 22px;
  color: #fff;
  margin: 60px auto;
}
::v-deep .el-form-item {
  margin-bottom: 20px;
}
.titleSize {
  margin-top: 5px !important;
  color: #000 !important;
}
.idCard img {
  width: 362px;
  height: 211px;
}
.line-s {
  //padding: 0 20px;
  margin: 40px 0;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 0px 0px;
  height: 4px;
  position: absolute;
  width: 100%;
  top: 1820px;
}
.size-s {
  color: #c8161d;
  font-size: 12px;
  margin-bottom: 5px;
}
.texts {
  color: #999;
  font-size: 12px;
  margin-top: 20px;
}
.imgWidth {
  position: relative;
  width: 128px;
  height: 128px;
}
video {
  position: absolute;
  width: 128px !important;
  height: 128px !important;
  margin-top: 0 !important;
  left: 0;
  top: 0;
}
.imgWidth img {
  position: absolute;
  width: 128px !important;
  height: 128px !important;
  margin-top: 0 !important;
  left: 0;
  top: 0;
}
.box-colors {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 6px 6px 6px 6px;
  width: 128px;
  height: 128px;
  position: absolute;
}
.img-ss {
  margin-right: 20px;
}
.img-s img {
  width: 40px;
  height: 40px;
  margin-top: 25px;
}
.upload {
  width: 128px;
  height: 128px;
  background: rgba(204, 204, 204, 0.3);
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 20px;
  margin-right: 20px;
}
::v-deep .area .el-input__inner {
  width: 820px;
  height: 65px;
  font-size: 18px;
}
.form {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding-bottom: 0;
}
::v-deep .el-form-item__label {
  font-size: 16px;
  color: #000;
}
::v-deep .centers .el-input__inner {
  text-align: center;
}
::v-deep .inputs .el-input__inner {
  width: 378px;
  height: 65px;
  font-size: 18px;
}
.flexs {
  display: flex;
  padding-right: 60px;
  background-color: #f9f9f9;
}
.banners {
  flex: 1;
  margin-top: 20px;
}
.content {
  width: 100%;
  padding: 30px 0 0 0;
  background-color: #fff;
  margin-top: 20px;
  box-shadow: 0px 2px 20px 0px rgba(135, 135, 135, 0.3);
  border-radius: 10px 10px 10px 10px;
  .systemTitle {
    display: flex;
    justify-content: space-between;
    //margin-top: 25px;
    position: relative;
    .button {
      background-color: #ffad41;
      color: #fff;
      font-size: 16px;
      height: 48px;
      border-radius: 10px 10px 10px 10px;
      line-height: 20px;
      position: absolute;
      right: 80px;
      top: 10px;
    }
    .titles {
      margin: 25px auto auto auto;
      color: #333;
      font-size: 28px;
      font-weight: 600;
    }
  }
  .title {
    //height: 49px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    padding-bottom: 10px;
    .name {
      margin-left: 10px;
      font-weight: 600;
    }
    .line {
      width: 5px;
      height: 19px;
      background: #c8161d;
    }
  }
}
.search-sel {
  padding: 20px;
  line-height: 40px;
}
</style>
